import createLogger from '@/lib/logger'

import type { RouteLocationNormalized } from 'vue-router'

const logger = createLogger('routeSanitisationGuard')

/**
 * Removes unnecessary parameters from the route
 */
export const routeSanitisationGuard = async (to: RouteLocationNormalized) => {
  logger.log('Running hook...')
  if (!to.hash.includes('#state=')) return

  logger.log('Removing #state hash')
  to.hash = ''
  return to
}
